export const auditTypes = {
	EMPLOYEE_OCCUPATION: { name: "Occupation" },
	LEAVE: {
		name: "Leave",
		keys: {
			source: {
				name: "#01#Submission Source",
				isNumericCode: true,
			},
			type: {
				name: "#02#Leave Type",
				isNumericCode: true,
			},
			date: {
				name: "#03#From",
				date: true,
			},
			startTime: {
				name: "#04#At",
				date: true,
			},
			dateTo: {
				name: "#05#To",
				date: true,
			},
			endTime: {
				name: "#06#Until",
				date: true,
			},
			hours: "#07#Total Hours",
			status: "#08#Leave Status",
			benefit: {
				name: "Special Benefit",
				isNumericCode: true,
			},
			sickType: {
				name: "Pay Type",
				isNumericCode: true,
			},
		},
	},
	TIMESHEET: {
		name: "Timesheet",
	},
	LEAVE_ADJUSTMENT: {
		name: "Leave Adjustment",
	},
	EMPLOYEE_ASSET: {
		name: "Employee Asset",
		keys: {
			employeeName: "Employee",
			startDate: {
				name: "From",
				date: true,
			},
			end: {
				name: "To",
				date: true,
			},
			dateReturned: {
				name: "Returned At",
				date: true,
			},
		},
	},
	ASSET: {
		name: "Asset",
		keys: {
			name: "Name",
			description: "Description",
			type: "Type",
			subType: "Subtype",
			cost: "Value",
			cashEquivalent: "Cash Equivalent",
			reference: "Reference",
			fuelType: "Fuel Type",
			engineType: "Engine Type",
			freeFuelProvided: "Free Fuel Provided",
			freeFuel: "Free Fuel Cash Equivalent",
			co2Emissions: "CO2 Emissions",
			numberPlate: "Number Plate",
			freeFuelWithdrawn: "Free Fuel Withdrawn",
			zeroEmissionMileage: "Zero Emission Mileage",
			model: "Model",
			make: "Make",
			isExempt: "Is Exempt",
			registeredDate: {
				name: "Date Registered",
				date: true,
			},
		},
	},
	EMPLOYEE_AGREEMENT_LINKED: {
		name: "Employee Portal",
	},
	EMPLOYEE_AGREEMENT_PENSION: {
		name: "Pension Plan",
		keys: {
			customPensionContribution: "Custom Pension Contributions",
			pensionGroup: {
				name: "Pension Group",
				isNumericCode: true,
			},
			employeeContribution: "Employee Contribution",
			employerContribution: "Employer Contribution",
			enrolmentBracketCode: "Auto Enrolment Bracket",
			optInDate: { name: "Scheme Opt In Date", date: true },
			optOutDate: { name: "Scheme Opt Out Date", date: true },
			enrolledDate: { name: "Scheme Date Enrolled", date: true },
			joinDate: { name: "Scheme Join Date", date: true },
		},
	},
	EMPLOYEE_ATTACHMENT_OF_EARNINGS: {
		name: "Attachment of Earnings",
		keys: {
			reference: "Reference",
			dateOfIssue: {
				name: "Date of Issue",
				date: true,
			},
			totalAmount: "Total Amount",
			type: "Type",
			paidBefore: "Amount Paid Before Creation",
			deduction: "Deduction",
			priority: "Priority",
			protectedEarnings: "Protected Earnings",
			attachmentRate: "Deduction Rate",
			deductFee: "Deduct Administration Fee",
		},
	},
	EMPLOYEE_AGREEMENT: {
		name: "Agreement",
		keys: {
			engagementDate: {
				name: "Engagement Date",
				date: true,
			},
			originalEngagement: {
				name: "Original Engagement",
				date: true,
			},
			familyName: "Last Name",
			givenName: "First Name",
			dateOfBirth: {
				name: "Date of Birth",
				date: true,
			},
			email: "Email",
			terminationDate: {
				name: "Termination Date",
				date: true,
			},
			enrolmentDeferredUntil: {
				name: "Enrolment Deferred Until",
				date: true,
			},
		},
	},
	MFA_RESET: {
		name: "MFA",
	},
	EMPLOYEE_COLA_ADJUSTMENT: {
		name: "Cost of Living Adjustment",
		keys: {
			salaryAmount: "Salary Amount",
		},
	},
	EMPLOYEE_AGREEMENT_TOTALS_TO_DATE: {
		name: "Totals to Date",
	},
	EMPLOYEE_AGREEMENT_CHILDREN: {
		name: "Children",
		keys: {
			reference: "#01#Reference",
			dateOfBirth: {
				name: "#02#Date of Birth",
				date: true,
			},
			adopted: "#03#Adopted",
			expectedDate: {
				name: "#04#Expected Date of Birth",
				date: true,
			},
			placementDate: {
				name: "#04#Placement Date",
			},
			hasCustody: "#05#Has Custody",
			custodyLostDate: {
				name: "#06#Date of Loss of Custody",
				date: true,
			},
			deceased: "#06#Deceased / Miscarriage",
			deceasedDate: {
				name: "#07#Date of Passing",
				date: true,
			},
		},
	},
	EMPLOYEE_PREVIOUS_EARNINGS: {
		name: "Previous Earnings",
		keys: {
			fringeBenefits: "Fringe Benefits",
			gross: "Gross Primary Income",
			incomeTax: "Income Tax",
			overtimeHours: "Overtime Hours",
			carAllowance: "Car Allowance",
			totalPreviousOvertimeEarned: "Overtime (Eligible for 15% Tax Deduction)",
			overtimeTax: "Tax Deductions (Eligible Overtime)",
		},
	},
	EMPLOYEE_AGREEMENT_SALARY: {
		name: "Salary",
		keys: {
			casual: "Variable Hours",
			previousHours: "Hours in Q4",
			payPeriodFrequencyName: "Every",
			payPeriodFrequency: {
				name: "Every",
				isNumericCode: true,
			},
			salaryAmount: "Salary Amount",
			isManagerial: "Overtime Tax Opt Out",
			paySchedule: {
				name: "Pay Schedule",
			},
			employmentType: {
				name: "Employment Type",
				isNumericCode: true,
			},
			employmentTypeName: "Employment Type",
			suspendBonus: "Suspend Bonus",
			weeklyHours: "Weekly Hours",
			net: {
				name: "Salary Type",
				customMap: ["Gross", "Net"],
			},
			workingDays: "Working Days",
			pensionGroup: {
				name: "Pension Group",
				isNumericCode: true,
			},
			pensionEmployee: "Pension Employee Contribution",
			pensionEmployer: "Pension Employer Contribution",
		},
	},
	EMPLOYEE_AGREEMENT_SALARY_ALLOWANCE: {
		name: "Salary Allowance",
	},
	EMPLOYEE_AGREEMENT_SALARY_OVERTIME: {
		name: "Salary Overtime",
		keys: {},
	},
	EMPLOYEE_AGREEMENT_ROLE: {
		name: "Role",
		keys: {
			name: "Role",
			description: "Description",
		},
	},
	EMPLOYEE_AGREEMENT_TAX: {
		name: "Tax",
		keys: {
			employmentStatus: {
				name: "Social Security Status",
				isNumericCode: true,
			},
			minimumTax: "Pays Minimum 10% NI",
			taxStatus: {
				name: "Tax Rate",
				isNumericCode: true,
			},
			sickBenefit: "Sick Benefit",
			employerPe: "Employer PE Number",
			customTaxRate: "Custom Tax Rate",
			studentLoan: {
				name: "Student Loan",
				isNumericCode: true,
			},
			postgradLoan: {
				name: "Postgraduate Loan",
				isNumericCode: true,
			},
			taxCode: "Tax Code",
			nicStatus: "NIC Status",
		},
	},
	EMPLOYEE_AGREEMENT_DEPARTMENT: {
		name: "Department",
		keys: {
			department: "Department",
		},
	},
	EMPLOYEE_BANK_DETAILS: {
		name: "Bank Details",
		keys: {
			payByCheque: {
				name: "Pay By",
				customMap: ["Bank", "Manual Transfer"],
			},
			bic: "BIC",
			bank: "Bank Account",
			accountHolder: "Account Holder",
			iban: "IBAN",
		},
	},
	PAYSLIP: {
		name: "Payslip",
		keys: {
			payItems: "Pay Items",
			gross: "Gross",
			ready: "Payslip Ready",
			net: "Net",
		},
	},
	EMPLOYEE_PERSONAL_DETAILS: {
		name: "Employee Details",
		keys: {
			engagementDate: {
				name: "engagementDate",
				date: true,
			},
			familyName: "Last Name",
			givenName: "First Name",
			dateOfBirth: {
				name: "Date of Birth",
				date: true,
			},
			email: "Email",
			spouseId: {
				MT: "Spouse ID",
				UK: "Spouse NI Number",
				name: "Spouse ID",
			},
			holidayPreference: {
				MT: "Public Holiday Preference",
				UK: "Bank Holiday Preference",
				name: "Holiday Preference",
				customMap: {
					UK: {
						"undefined": "England and Wales",
						"scotland": "Scotland",
						"northern-ireland": "Northern Ireland",
					},
				},
			},
			gender: "Gender",
			city: "City",
			county: "County",
			houseNumber: "House Number",
			taxNumber: "Tax Number",
			reference: "Employee Reference Code",
			companyEmail: "Company Email",
			companyPhone: "Company Phone",
			nationality: "Nationality",
			nationalID: "National ID",
			maritalStatus: "Marital Status",
			phone: "Phone Number",
			street: "Street",
			responsibleSpouse: "Responsible Spouse",
			postCode: "Post Code",
			marriageDate: {
				name: "Date of Marriage",
				date: true,
			},
			payrollId: "Payroll ID",
			hasChildren: "Has Children",
			spouseFamilyName: "Spouse Last Name",
			spouseGivenName: "Spouse First Name",
			spouseInitials: "Spouse Initials",
			socialSecurity: {
				MT: "Social Security",
				UK: "NI Number",
				name: "Social Security",
			},
		},
	},
	EMPLOYEE_GRADE: {
		name: "Grade",
	},
	ORGANISATION_DETAILS: {
		name: "Organisation Details",
	},
	ORGANISATION_SETTINGS: {
		name: "Organisation Settings",
	},
	GRADE: {
		name: "Grade",
	},
	MARKDOWN_TEMPLATE: {
		name: "Markdown Template",
	},
};

export const codeList = {
	"105": "Hour",
	"104": "Day",
	"103": "Week",
	"102": "Month",
	"101": "Year",
	"504": "Other",
	"502": "Part-time",
	"501": "Full-time",
	"1843110": "External Contractor",
	"SL1T": "Plan 1",
	"SL2T": "Plan 2",
	"SL4T": "Plan 4",
	"PGL": "Yes",
	"FP": "Full Pay Sick",
	"HP": "Half Pay Sick",
	"UP": "Unpaid Sick",
	"SB": "Sick Benefit",
	"SSP": "Statutory Sickness Benefit",
	"employee": "Employee Portal",
	"manager": "Manager Portal",
	"hr": "Admin Portal",
};

export const filterFields = [
	"id",
	"updatedAt",
	"agreement",
	"createdAt",
	"weeklySalary",
	"hourlySalaryAmount",
	"isIncomplete",
	"company",
	"replace",
	"effectiveFrom",
	"agreementId",
	"org",
	"orgIsPaid",
	"isParentEntry",
	"isPaid",
	"employee",
	"assignedInProcessTimesheets",
	"agreementIsPaid",
	"applicationDate",
];
